var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tree',{attrs:{"data":_vm.treeData,"render":_vm.renderContent,"show-checkbox":_vm.showCheckbox},on:{"on-select-change":_vm.selectData,"on-check-change":_vm.checkChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }